import { useFeatureFlags } from '@funtech-int/yango-shared';

import { featureFlagsScheme } from '../../../lib/featureFlags';
import { AppErrors } from '../../error-boundary-context/error-map/map';
import { useHandleError } from '../../error-boundary-context/context';

export const useDefaultOnError = () => {
    const { flags } = useFeatureFlags(featureFlagsScheme);
    const handleError = useHandleError();

    const defaultPlayerError = flags.get('defaultPlayerError');
    const onError = () => handleError(defaultPlayerError as AppErrors);
    return onError;
};
